import { render, staticRenderFns } from "./TosfDashboard.vue?vue&type=template&id=4a862187&scoped=true"
import script from "./TosfDashboard.vue?vue&type=script&lang=js"
export * from "./TosfDashboard.vue?vue&type=script&lang=js"
import style0 from "./TosfDashboard.vue?vue&type=style&index=0&id=4a862187&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a862187",
  null
  
)

export default component.exports